var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('button',{staticClass:"kakao_login_wrap",on:{"click":function($event){return _vm.triggerKakao()}}},[_c('a',{staticStyle:{"display":"none"},attrs:{"id":"kakao-login-btn"}}),_c('img',{attrs:{"src":require("@/assets/image/main/kakao.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }